import React from 'react';
import { useSelector } from 'react-redux';

export default function useErrorSelector() {
  const ErrorStatus = useSelector((state) => state.error.errorData);
  return { ErrorStatus };
}
